import { authRoles } from "../../../auth/authRoles";
import EditPortfolio from "./EditPortfolio";
import Portfolio from "./Portfolio";
import TambahPortfolio from "./TambahPortfolio";

const portfolioRoutes = [
  {
    path: "/portfolio/edit/:id",
    exact: true,
    component: EditPortfolio,
    auth: authRoles.all,
  },
  {
    path: "/portfolio/tambah",
    exact: true,
    component: TambahPortfolio,
    auth: authRoles.all,
  },
  {
    path: "/portfolio",
    exact: true,
    component: Portfolio,
    auth: authRoles.all,
  },
];

export default portfolioRoutes;
